
import React, {Component} from 'react'
import PropTypes from 'prop-types'

const CLASS_NAME = 'octicon octicon-arrow-small-up'
class ArrowSmallUpIcon extends Component {
  render() {
    let defaults = {
      height: 16,
      width: 6,
      viewBox: '0 0 6 16',
      'aria-hidden': true
    }

    let {className, size} = this.props
    if (className) {
      className = CLASS_NAME + ' ' + className
    } else {
      className = CLASS_NAME
    }

    if (size === 'mega') {
      defaults.height *= 2
      defaults.width *= 2
    }

    return (
      <svg {...defaults} {...this.props} className={className}>
        <path fillRule="evenodd" d="M3 5L0 9h2v2h2V9h2z"/>
      </svg>
    )
  }
}
ArrowSmallUpIcon.propTypes = {
  className: PropTypes.string
}
export default ArrowSmallUpIcon
